import { useEffect, useState } from 'react';
import { useCurrentModule } from '../components';
import { ECLIPSE_MOBILE_MODULE_NAME } from '../utils/moduleNames';
import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
import { useEclipsePlanRecommendation } from './useEclipsePlanRecommendation';
const DECIDING_MS = 1200;
const DESKTOP_BEAT = {
  analyzingMinMs: 1500,
  analyzingMinWithoutGeneratedMs: 2500,
  analyzingMaxMs: 12000
};
const MOBILE_BEAT = {
  analyzingMinMs: 1000,
  analyzingMinWithoutGeneratedMs: 1000,
  analyzingMaxMs: 4000
};
export const useAiRevealController = () => {
  const module = useCurrentModule();
  const beat = module.moduleName === ECLIPSE_MOBILE_MODULE_NAME ? MOBILE_BEAT : DESKTOP_BEAT;
  const {
    isEnabled,
    showsGeneratedContent
  } = useAiRecommendationEnabled();
  const {
    isBulletsLoading
  } = useEclipsePlanRecommendation();
  const isDeciding = module.SDK.aiRecommendationStore.useIsDeciding();
  const isRevealed = module.SDK.aiRecommendationStore.useIsRevealed();
  const plansRendered = module.SDK.aiRecommendationStore.useArePlansRendered();
  const recommendedProductId = module.SDK.aiRecommendationStore.useRecommendedProductId();
  const [floorReached, setFloorReached] = useState(false);
  const analyzingMinMs = showsGeneratedContent ? beat.analyzingMinMs : beat.analyzingMinWithoutGeneratedMs;
  const analyzingMaxMs = beat.analyzingMaxMs;
  const isWaitingForRecommendation = showsGeneratedContent ? isBulletsLoading : !recommendedProductId;
  useEffect(() => {
    if (!isEnabled || isDeciding || isRevealed || !plansRendered) {
      return undefined;
    }
    const floor = setTimeout(() => setFloorReached(true), analyzingMinMs);
    const ceiling = setTimeout(() => module.SDK.aiRecommendationStore.decide(), analyzingMaxMs);
    return () => {
      clearTimeout(floor);
      clearTimeout(ceiling);
    };
  }, [isEnabled, isDeciding, isRevealed, plansRendered, analyzingMinMs, analyzingMaxMs, module]);
  useEffect(() => {
    if (isEnabled && plansRendered && floorReached && !isWaitingForRecommendation && !isDeciding && !isRevealed) {
      module.SDK.aiRecommendationStore.decide();
    }
  }, [isEnabled, plansRendered, floorReached, isWaitingForRecommendation, isDeciding, isRevealed, module]);
  useEffect(() => {
    if (!isDeciding || isRevealed) {
      return undefined;
    }
    const timer = setTimeout(() => module.SDK.aiRecommendationStore.reveal(), DECIDING_MS);
    return () => clearTimeout(timer);
  }, [isDeciding, isRevealed, module]);
};
//# sourceMappingURL=useAiRevealController.js.map